var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 6.75V3.75C2.25 3.35218 2.40804 2.97064 2.68934 2.68934C2.97064 2.40804 3.35218 2.25 3.75 2.25H6.75M2.25 17.25V20.25C2.25 20.6478 2.40804 21.0294 2.68934 21.3107C2.97064 21.592 3.35218 21.75 3.75 21.75H6.75M21.75 6.75V3.75C21.75 3.35218 21.592 2.97064 21.3107 2.68934C21.0294 2.40804 20.6478 2.25 20.25 2.25H17.25M21.75 17.25V20.25C21.75 20.6478 21.592 21.0294 21.3107 21.3107C21.0294 21.592 20.6478 21.75 20.25 21.75H17.25",
    stroke: "#204887",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12.5833C13.5973 12.5833 15.05 13.046 16.1187 13.698C16.652 14.0233 17.108 14.4073 17.4373 14.8247C17.7613 15.2347 18 15.7253 18 16.25C18 16.8133 17.726 17.2573 17.3313 17.574C16.958 17.874 16.4653 18.0727 15.942 18.2113C14.89 18.4893 13.486 18.5833 12 18.5833C10.514 18.5833 9.11 18.49 8.058 18.2113C7.53467 18.0727 7.042 17.874 6.66867 17.574C6.27333 17.2567 6 16.8133 6 16.25C6 15.7253 6.23867 15.2347 6.56267 14.824C6.892 14.4073 7.34733 14.024 7.88133 13.6973C8.95 13.0467 10.4033 12.5833 12 12.5833ZM12 5.25C12.8841 5.25 13.7319 5.60119 14.357 6.22631C14.9821 6.85143 15.3333 7.69928 15.3333 8.58333C15.3333 9.46739 14.9821 10.3152 14.357 10.9404C13.7319 11.5655 12.8841 11.9167 12 11.9167C11.1159 11.9167 10.2681 11.5655 9.64298 10.9404C9.01786 10.3152 8.66667 9.46739 8.66667 8.58333C8.66667 7.69928 9.01786 6.85143 9.64298 6.22631C10.2681 5.60119 11.1159 5.25 12 5.25Z",
    fill: "#204887"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScan);
export default __webpack_public_path__ + "static/media/Scan.fbb613dd583f4070956a2d437d64370d.svg";
export { ForwardRef as ReactComponent };